module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-supply-chain-tailored-supply-chain.843b65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-supply-chain-tailored-supply-chain.jpg
// module id = McQQ
// module chunks = 0